import React from "react";
import { List, Datagrid, TextField, EmailField } from "react-admin";

export default (props) => (
  <List {...props}>
    <Datagrid rowClick="edit">
      <TextField source="name" />
      <TextField source="company" />
      <EmailField source="email" />
      <TextField source="access" />
    </Datagrid>
  </List>
);
